import { AllServiceRatingCode, CustomServiceRatingCode } from './Services.enum';
import { ActivityCode, ContentType, ExtServiceApi, ProjectCode, SearchType } from 'pleinchamp-api-client';
import { ApiConfiguration, axiosInstance } from '@api/business/api.conf';
import { searchContent, SearchParams } from '@search/business/search.utils';
import { Constants } from '@utils/Constants';

export const serviceApi = new ExtServiceApi(ApiConfiguration, undefined, axiosInstance);
export const NB_SERVICES_PER_PAGE = 12;

// TODO: which query for the services news?
export function fetchServicesNews() {
  return searchContent({
    contentTypes: [ContentType.Article],
    limit: Constants.FEATURED_NEWS_LIMIT,
    query: '',
    searchType: SearchType.Prioritize,
  }).then(data => data.contents);
}

export function fetchServices(
  activities?: ActivityCode[],
  projects?: ProjectCode[],
  serviceRating?: AllServiceRatingCode,
  offset = 0,
  limit = NB_SERVICES_PER_PAGE
) {
  const searchParams: SearchParams = {
    activities,
    contentTypes: [ContentType.PlcService, ContentType.AffiliateService],
    limit,
    offset,
    projects,
    serviceRating: serviceRating === CustomServiceRatingCode.All ? undefined : serviceRating,
  };
  return searchContent(searchParams);
}
